<template>
    <layout-internal-container>
        <!-- <div class="w-full flex flex-col gap-5">
            <div class="flex flex-row items-center justify-between">
                <span class="font-medium text-light">Recent Joined Program</span>
                <a-button @click="$router.push('/Internal/Calendar')" type="text"
                    class="text-primary flex flex-row justify-center items-center gap-2">
                    <span class="font-medium">View All</span>
                    <IconArrowRight :size="18" />
                </a-button>
            </div>
            <div class="w-full gap-4 grid sm:grid-cols-2 xl:grid-cols-3">
                <card-program enrolled v-for="item in programs" :key="item.id" :name="item.name" :id="item.id" :image="item.image"
                    :description="item.description" :type="item.type"  :status="item.status" :date="item.date" />
            </div>
        </div> -->
    </layout-internal-container>
</template>
  
<script setup>
// import { ref } from 'vue'
// import DummyCourse from '../../assets/Dummy/course.js'
// import DummyPrograms from '../../assets/Dummy/program.js'
// import { IconSearch, IconSortDescending, IconCategory2, IconChartDonut, IconCalendarMonth, IconTrophy, IconAlarm, IconHourglassEmpty, IconCertificate2, IconRotateClockwise2, IconArrowRight } from '@tabler/icons-vue'

// const tab = ref('All')
// const courses = ref(DummyCourse.slice(0, 4))
// const programs = ref(DummyPrograms)
</script>
  